// css =>
import "../../BaseStructure.css";
import Styled from "./category-filter-sub-menu.module.css";

// react =>
import { useState, useEffect } from "react";

// language =>
import { getTranslation } from '../../i18n/get-translation';
import { useLanguage } from '../../context/language-context';
import { getTranslatedField } from '../../utils/get-translated-field';

// context =>
import { useTheme } from '../../context/theme-context';

const CategoryFilterSubMenu = (props) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1200);

    const [selectedFilterItem, setSelectedFilterItem] = useState("None");
    const [selectedCategoryItem, setSelectedCategoryItem] = useState("All");

    const { language } = useLanguage();
    const t = (key) => getTranslation(language, key);

    const { theme, toggleTheme } = useTheme();

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1200);
        };
    
        window.addEventListener("resize", handleResize);
    
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <>
            {
                props.isOpen && <div
                                    className={ Styled.backdrop }
                                    onClick={ props.cloesWithBackdrop }></div>
            }

            <div 
                className={`row ${ Styled.category_filter_sub_menu_box_section } `}
                style={{
                    display: props.isOpen ? "flex" : "none",
                }}>
                <div 
                    className={`row ${ Styled.category_filter_sub_menu } `} 
                    style={{
                        height: isMobile && !props.haveFilterBox ? "120px" : !isMobile && !props.haveFilterBox ? "210px" : null,
                        backgroundColor: theme === "day" ? "#C9CCC2" : ""
                    }}>
                    {
                        props.haveFilterBox ? (
                            <>
                                <div className={`row ${ Styled.filter_box_header } `}>
                                    <div className="col-2">
                                        <p
                                            className={ Styled.filter_title_text }
                                            style={{
                                                color: theme === "day" ? "#000000" : "",
                                                textAlign: language === "fa" ? "right" : ""
                                            }}>{ t('filterTitle') }</p>
                                    </div>
                                    <div className="col-9">
                                        <hr
                                            style={{
                                                borderColor: theme === "day" ? "#474D3D" : ""
                                            }}/>
                                    </div>
                                </div>

                                <div
                                    className={`row ${ Styled.filter_box_body } `}
                                    style={{
                                        marginRight: language === "fa" ? "10px" : ""
                                    }}>
                                    <div
                                        style={{
                                            backgroundColor: theme === "day" ? "#474D3D" : ""
                                        }}
                                        className={`col-3 ${ Styled.filter_option_box } ${ selectedFilterItem === "None" ? Styled.active : "" } `} onClick={() => {
                                        setSelectedFilterItem("None");
                                        props.handleFilterChange("");
                                    }}>
                                        <p>{ t('categoryFilterSubMenuOption1') }</p>
                                    </div>
                                    <div
                                        style={{
                                            backgroundColor: theme === "day" ? "#474D3D" : ""
                                        }}
                                        className={`col-3 ${ Styled.filter_option_box } ${ selectedFilterItem === "Indoor" ? Styled.active : "" } `} onClick={() => {
                                        setSelectedFilterItem("Indoor");
                                        props.handleFilterChange("indoor");
                                    }}>
                                        <p>{ t('categoryFilterSubMenuOption2') }</p>
                                    </div>
                                    <div
                                        style={{
                                            backgroundColor: theme === "day" ? "#474D3D" : ""
                                        }}
                                        className={`col-3 ${ Styled.filter_option_box } ${ selectedFilterItem === "Outdoor" ? Styled.active : "" } `} onClick={() => {
                                        setSelectedFilterItem("Outdoor");
                                        props.handleFilterChange("outdoor");
                                    }}>
                                        <p>{ t('categoryFilterSubMenuOption3') }</p>
                                    </div>
                                </div>
                            </>
                        ) : null
                    }

                    <div className={`row ${ Styled.category_box_header } `}>
                        <div className="col-2">
                            <p
                                className={ Styled.filter_title_text }
                                style={{
                                    color: theme === "day" ? "#000000" : "",
                                    textAlign: language === "fa" ? "right" : ""
                                }}>{ t('categoryTitle') }</p>
                        </div>
                        <div className="col-9">
                            <hr
                                style={{
                                    borderColor: theme === "day" ? "#474D3D" : ""
                                }}/>
                        </div>
                    </div>

                    <div
                        className={`row ${ Styled.category_box_body } `}
                        style={{
                            marginRight: language === "fa" ? "10px" : ""
                        }}>
                        <div
                            className={`col-3 ${ Styled.filter_option_box } ${ selectedCategoryItem === "All" ? Styled.active : null } `}
                            onClick={() => {
                                setSelectedCategoryItem("All");
                                props.handleCategoryFilterChange("");
                            }}>
                            <p>{ t('categoryFilterSubMenuOption4') }</p>
                        </div>
                        {
                            props.categorys ? (
                                props.categorys?.map((item) => {
                                    return <div
                                        className={`col-3 ${ Styled.filter_option_box } ${ selectedCategoryItem === item.name_en ? Styled.active : null } `}
                                        style={{
                                            backgroundColor: theme === "day" ? "#474D3D" : ""
                                        }}
                                        onClick={() => {
                                            setSelectedCategoryItem(item.name_en);
                                            props.handleCategoryFilterChange(item.id);
                                        }}>
                                        <p>{ getTranslatedField(item, "name", language) }</p>
                                    </div>
                                })
                            ) : (
                                <p>{ t('noContent') }</p>
                            )
                        }
                    </div>
                </div>
            </div>
        </>
    );
}

export default CategoryFilterSubMenu;
